import React, { useEffect, useState } from 'react'
import Breadcrumb from '../Components/Breadcrumb'
import { Link } from 'react-router-dom'
import Pagehelmet from '../Components/Pagehelmet'
import { useParams } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'
const TicketType = () => {
    const { id } = useParams();
    const location = useLocation();
    console.log(id, 'event')
     const { event } = location.state || {};
    const [data, setData] = useState([]);

    console.log(data, 'ticket type')
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const url = `${process.env.REACT_APP_API_URL}/tickettypes/view-by-event-id`;
    const headers = {
        Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.post(url, { "event": id }, { headers });
            const sortedData = response?.data?.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            ) || [];
            setData(sortedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        id && fetchData();
    }, [1000]);












    return (
        <div>
            <Pagehelmet pageTitle="Our Pricings" />
            <Breadcrumb title="21 St Annual Summer Camp Event Packages" />
            {/*--Pricing Section start--*/}
            <section className="price bg-lightgrey">
                <div className="container">
                    <div className="price-inner text-center">
                        <div className="price-title mb-7 w-lg-60 m-auto">
                            <p className="mb-1 pink">PRICING PLANS</p>
                            <h2 className="mb-1">EXPLORE FLEXIBLE <span className="pink">PRICING</span> PLANS</h2>
                            {/* <p className="m-0">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim
                            id est laborum.</p> */}
                        </div>


                        <div className="price-options g-2 pb-6">
                            <div className="row">


                                {
                                    data && data?.map(x => (
                                        <div className="col-lg-4 col-md-6 mb-8" key={x.id}  >
                                            <div className="ticket-box-inner bg-white position-relative rounded-bottom-5">
                                                <img src={require("../assets/images/pattern/2.png")} alt="pattern" className="w-100 pattern position-absolute rounded-top" />
                                                <div className="ticket-title py-6 bg-pink text-white ">
                                                    <h6 className="text-white  mb-1"> {x?.name}</h6>

                                                </div>
                                                <div className="ticket-price bg-white py-6">
                                                    <div className="ticket-price-inner d-flex justify-content-center align-items-start fw-bold">
                                                        <span className="me-1 m-0 dollor pink">{x?.price}</span>

                                                        <span className="me-1 mb-0 currency pink">ETB</span>
                                                        <span className="me-1 mb-0 currency pink"> </span>
                                                    </div>
                                                    {/* <p className="m-0">Person</p> */}
                                                </div>
                                                <div className="benifit-list bg-white">
                                                    <ul className=" m-auto p-0 list-unstyled">
                                                        <li className="pb-2 border border-0 text-capitalize lh-1">
                                                            <p className="my-1"><small> {x?.description}</small></p>
                                                        </li>

                                                    </ul>
                                                </div>
                                                <div className="partner-button  m-auto p-6">
                                                    <Link
                                                        to="/BookTickets"
                                                        state={{
                                                            event: event,           // your event object or ID
                                                            TicketType: x       // your ticket type ID or object
                                                        }}
                                                        className="btn"
                                                    >
                                                        Book Now
                                                    </Link>
                                                    <p className="mt-4"><small>*Please read our term and condition before order ticket</small></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }


                            </div>
                        </div>
                        <p className="m-0">All prices exclude 25% VAT. For more details, view our <a className="pink">Terms & Policy</a></p>
                    </div>
                </div>
            </section>
            {/*--Pricing Section end--*/}


            {/*--Ticketbook Section start--*/}
            {/* <section className="ticket2 position-relative pb-0">
        <div className="container">
            <div className="ticket-inner  text-center position-relative">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="ticket-left text-lg-start pb-6">
                            <div className="ticket-title">
                                <p className="mb-1 pink ">LET'S DO IT HURRY</p>
                                <h2 className="mb-2">HAVEN'T BOOKED YOUR SEAT YET? <span className='pink'>Get Ticket</span></h2>
                            </div>
                            <div className="ticket-info">    
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                                <div className="ticket-button">
                                    <Link to="/Booknow" className='btn'>GET TICKETS NOW</Link>
                                </div>  
                            </div>
                        </div>  
                    </div> 
                    <div className="col-lg-6">
                        <div className="ticket-right">
                            <img src="assets/images/team/5.png" alt="ticket-img" className="w-50"/>
                        </div>
                    </div>
            </div>
            </div>  
        </div>
        </section> */}
            {/*--Ticketbook Section end--*/}
        </div>
    )
}

export default TicketType